<template>
  <el-dropdown size="medium" placement="left-start" @command="handleCommand">
    <div class="user-card" :class="{ 'is-collapse': isCollapse }">
      <i class="fas fa-user-circle user-icon" />
      <div class="user-info" v-if="!isCollapse">
        <div class="user-name">{{ user.realName }}</div>
        <div class="user-role">{{ user.roleNames }}</div>
      </div>

      <div v-if="!isCollapse">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <template slot="dropdown">
      <el-dropdown-menu>
        <el-dropdown-item command="switchEnterprise" v-if="showEntSwitchBtn">
          <i class="el-icon-s-home"></i>
          <b>{{ entBriefName }}</b>
          <span>&nbsp;&nbsp;切换<i class="el-icon-arrow-right"></i></span>
        </el-dropdown-item>
        <el-dropdown-item divided command="profile">
          <i class="el-icon-user"></i>
          <span>个人中心</span>
        </el-dropdown-item>
        <el-dropdown-item command="basicInfo" v-permission="['center:info']">
          <i class="el-icon-info"></i>
          <span>基本信息</span>
        </el-dropdown-item>
        <el-dropdown-item divided command="logout">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>

    <!-- 切换企业弹窗组件 -->
    <EntSwitcher ref="entSwitcher" confirmButtonText="切 换"></EntSwitcher>
  </el-dropdown>
</template>
<script>
import { getEnterpriseList } from '@/api/login'
import EntSwitcher from '@/components/EntSwitcher'
import { mapGetters } from 'vuex'
export default {
  name: 'UserCard',
  components: { EntSwitcher },
  computed: {
    ...mapGetters(['user', 'sidebar']),
    // 是否折叠
    isCollapse() {
      return !this.sidebar.opened
    },
    // 是否显示切换企业按钮
    showEntSwitchBtn() {
      return this.user.enterpriseList && this.user.enterpriseList.length > 1
    },
    entBriefName() {
      if (!this.user.enterpriseList) return undefined
      let entObj = this.user.enterpriseList.find(item => item.entCode == this.user.entCode)
      if (!entObj) return undefined
      return entObj.entBriefName
    },
    currentUser() {
      if (!this.user.enterpriseList) return {}
      let entObj = this.user.enterpriseList.find(item => item.entCode == this.user.entCode)
      return entObj
    },
  },
  methods: {
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout()
      } else if (command === 'profile') {
        this.handleProfile()
      } else if (command === 'switchEnterprise') {
        this.handleSwitchEnterprise()
      } else if (command === 'basicInfo') {
        this.handleBasicInfo()
      }
    },
    // 个人中心
    handleProfile() {
      this.$router.push({ path: '/user/center' })
    },
    // 基本信息
    handleBasicInfo() {
      this.$router.push({ path: '/enterpriseSetting/center' })
    },
    // 退出登录
    handleLogout() {
      this.$confirm('确定退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()
        })
      })
    },
    // 切换企业
    handleSwitchEnterprise() {
      getEnterpriseList().then(res => {
        const enterpriseList = res || []
        this.$refs.entSwitcher.openDialog(enterpriseList)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dropdown {
  width: 100%;
}
/* 用户信息卡片 */
.user-card {
  padding: 12px 20px;
  border-top: 1px solid #E5E7EB;
  display: flex;
  align-items: center;
  gap: 12px;
  position: sticky;
  bottom: 0;
  z-index: 100;
  background: #fff;
  cursor: pointer;

  i.user-icon {
    font-size: 30px;
    color: #9CA3AF;
  }

  &.is-collapse {
    padding: 12px 0;
    justify-content: center;
  }

  .user-info {
    flex: 1;

    .user-name {
      font-size: 14px;
      font-weight: bold;
      color: #212529;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100px;
    }

    .user-role {
      font-size: 12px;
      color: #9CA3AF;
      margin-top: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .dropdown-icon {
    color: #9CA3AF;
  }
}
</style>
